export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";